
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

import config from '@/config/index'
import { getOrderDetail } from '@/api/youzheng.js'
import errorImg from '@/assets/mall/img-error.png'
import Storage from '@/storage'
export default {
name: 'orderdetail',
components: {
Flexbox,
FlexboxItem,
Cell,
Group
},
data () {
return {
baseUrl: config.baseUrl,
errorImg: errorImg,
orderid: this.$route.params.id,
openid: Storage.get('openId'),
orderObj: {}
}
},
created () {
this.getDetail()
},
computed: {
accountid () {
return this.$store.state.user.ID
}
},
methods: {
onImgError ($event) {
$event.target.src = this.errorImg
},
getDetail () {
getOrderDetail({
orderid: this.orderid,
accountid: this.accountid,
openid: this.openid
}).then(data => {
this.orderObj = data.returnValue
})
},

godetail (id) {
this.$router.push({ name: 'mallProductDetail', params: { id: id } })
}
}
}
